<template>
<div class="chapter">
<div class="inner_page">
<div class="toc" id="toc">
<h1 class="toc"><em>Contents</em></h1>
<p class="center"><a class="hlink" href="#/OEBPS/9781449400187_epub_ack_r1.htm">ACKNOWLEDGMENTS</a></p>
<p class="center"><a class="hlink" href="#/OEBPS/9781449400187_epub_int_r1.htm">INTRODUCTION</a></p>
<p class="center"><img alt="" src="OEBPS/images/9781449400187_comman.jpg"/></p>
<p class="center"><a class="hlink" href="#/OEBPS/9781449400187_epub_c01_r1.htm"><span class="small01">CHAPTER 1</span> <span class="big2">SOUTHERN APPALACHIA</span></a></p>
<p class="center"><a class="hlink" href="#/OEBPS/9781449400187_epub_c02_r1.htm"><span class="small01">CHAPTER 2</span> <span class="big2">BREAKFAST</span></a></p>
<p class="center"><a class="hlink" href="#/OEBPS/9781449400187_epub_c03_r1.htm"><span class="small01">CHAPTER 3</span> <span class="big2">APPETIZERS</span></a></p>
<p class="center"><a class="hlink" href="#/OEBPS/9781449400187_epub_c04_r1.htm"><span class="small01">CHAPTER 4</span> <span class="big2">SOUPS <span class="small01">AND</span> SALADS</span></a></p>
<p class="center"><a class="hlink" href="#/OEBPS/9781449400187_epub_c05_r1.htm"><span class="small01">CHAPTER 5</span> <span class="big2">VEGETABLES <span class="small01">AND</span> BEANS</span></a></p>
<p class="center"><a class="hlink" href="#/OEBPS/9781449400187_epub_c06_r1.htm"><span class="small01">CHAPTER 6</span> <span class="big2">BREADS, MUFFINS, ROLLS, <span class="small01">AND</span> BISCUITS</span></a></p>
<p class="center"><a class="hlink" href="#/OEBPS/9781449400187_epub_c07_r1.htm"><span class="small01">CHAPTER 7</span> <span class="big2">MEATS, FISH, <span class="small01">AND</span> SEAFOOD</span></a></p>
<p class="center"><a class="hlink" href="#/OEBPS/9781449400187_epub_c08_r1.htm"><span class="small01">CHAPTER 8</span> <span class="big2">DESSERTS, COOKIES, CAKES, <span class="small01">AND</span> TEA CAKES</span></a></p>
<p class="center"><a class="hlink" href="#/OEBPS/9781449400187_epub_c09_r1.htm"><span class="small01">CHAPTER 9</span> <span class="big2">BEVERAGES</span></a></p>
<p class="center"><a class="hlink" href="#/OEBPS/9781449400187_epub_c10_r1.htm"><span class="small01">CHAPTER 10</span> <span class="big2">COUNTRY STORE</span></a></p>
<p class="center"><img alt="" src="OEBPS/images/9781449400187_comman.jpg"/></p>
<p class="center"><a class="hlink" href="#/OEBPS/9781449400187_epub_bm1_r1.htm">SOURCES <span class="small">AND</span> RESOURCES</a></p>
<p class="center"><a class="hlink" href="#/OEBPS/9781449400187_epub_bm2_r1.htm">METRIC CONVERSIONS <span class="small">AND</span> EQUIVALENTS</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781449400187_epub_toc_r1.vue?5c8cbf8a